<template>
    <div>
          <h1 class="mt-5">Budapest Escort Girl</h1>
          <h2 class="mt-3">Welcome to Budapest Escort Girl</h2>
          <p>
              Book an appointment from home via SMS. This website offers the opportunity to contact the lady of Budapest with a NORMAL RATE SMS text message. The main advantage of this system is that it helps to avoid high telephone numbers and also avoids possible language difficulties as it allows everyone to communicate through their own language or translators. The Budapest advertising girl has her own Hungarian (36) phone number, but only via SMS. Phones are not able to receive calls, only SMS.
              <br>
              Have a nice time in Budapest.
          </p>
          <h2 class="mt-3">Escort girls in Budapest.</h2>
          <p>
              The Hungarian girls are very pretty and kind. If you want to experience why you are in the right place. On the website you will find only Hungarian ladies who will pay all their attention to you. It is safe and satisfying to meet you at your hotel, book comfortably a sympathetic girl!
          </p>                  
    </div>
</template>

<script>
export default {
    name: "WelcomeComponent"
}
</script>
